import {
  Theme as LibraryTheme,
  ThemeSwitch as BaseThemeSwitch
} from '@platform/ui-library';
import { FC } from 'react';
import { useUserSettings } from '@app/hooks';
import { Theme } from '@app/types';

export const ThemeSwitch: FC = () => {
  const theme = useUserSettings((state) => state.theme);
  const setTheme = useUserSettings((state) => state.setTheme);

  return (
    <div className='theme-switch'>
      <BaseThemeSwitch
        onChange={(newTheme) => setTheme((newTheme === LibraryTheme.Dark) ? Theme.dark : Theme.light)}
        value={(theme == Theme.dark) ? LibraryTheme.Dark : LibraryTheme.Light}
      />
    </div>
  );
};
